import { Cancel } from "@mui/icons-material";
import { Box, Tooltip, Typography } from "@mui/material";
import { clearBulletPointVariants } from "../../api/batches";
import {
  BulletPoint,
  BulletPointColors,
  BulletPointType,
} from "../../pages/playground/types";
import EditorBulletPoints from "./bullet-points";
import { useState } from "react";

export default function BulletPointsList({
  bulletPoint,
  onRefresh,
  setBulletPointToCopy,
  bulletPointToCopy,
}: {
  bulletPoint: BulletPoint;
  onRefresh: () => void;
  setBulletPointToCopy?: (value: string | null) => void;
  bulletPointToCopy?: string | null;
}) {
  const [isAddingVariant, setIsAddingVariant] = useState(false);

  const bulletPointName =
    bulletPoint.type === BulletPointType.CUSTOM
      ? bulletPoint.custom_name || "Custom"
      : bulletPoint.type
          ?.split("_")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ");

  return (
    <Box
      sx={{
        backgroundColor: BulletPointColors[bulletPoint.type],
        padding: "0.15rem 0.30rem 0.35rem 0.30rem",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "top",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: "0.85rem",
              color: "rgba(0, 0, 0, 0.8)",
            }}
            key={bulletPoint.type}
          >
            {bulletPointName}
          </Typography>
          {bulletPoint.custom_description && (
            <Tooltip title={bulletPoint.custom_description} placement="right">
              <Typography
                sx={{
                  fontSize: "0.65rem",
                  color: "rgba(0, 0, 0, 0.5)",
                  fontStyle: "italic",
                  maxWidth: "150px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  cursor: "help",
                }}
              >
                {bulletPoint.custom_description.length > 20
                  ? `${bulletPoint.custom_description.slice(0, 20)}...`
                  : bulletPoint.custom_description}
              </Typography>
            </Tooltip>
          )}
        </Box>

        {/* Cancel button to clear all variants */}
        {bulletPoint.variants.length > 0 && (
          <Tooltip title="Clear all variants" placement="top">
            <Cancel
              sx={{
                fontSize: "1rem",
                cursor: "pointer",
                color: "rgba(0, 0, 0, 0.4)",
                "&:hover": {
                  color: "red",
                },
              }}
              onClick={async () => {
                await clearBulletPointVariants({
                  bulletpointId: bulletPoint.id,
                });
                onRefresh();
              }}
            />
          </Tooltip>
        )}

        {/* {!bulletPointToCopy && isEmptyVariant && (
          <>
            {isAddingVariant ? (
              <Cancel
                sx={{
                  fontSize: "1rem",
                  cursor: "pointer",
                }}
                onClick={async () => {
                  setIsAddingVariant(false);
                }}
              />
            ) : (
              <Add
                sx={{
                  fontSize: "1rem",
                  cursor: "pointer",
                }}
                onClick={async () => {
                  setIsAddingVariant(true);
                }}
              />
            )}
          </>
        )} */}

        {/* {!isEmptyVariant && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mt: 0.3,
              gap: "0.40rem",
            }}
          >
            <Tooltip
              enterDelay={1500}
              enterNextDelay={1500}
              placement="top"
              title={
                isPartOfEditorialDescription
                  ? "Remove from Editorial"
                  : "Add to Editorial"
              }
            >
              <Box component="span" sx={{ display: "inline-block" }}>
                {isPartOfEditorialDescription ? (
                  <TextFormat
                    sx={{
                      fontSize: "1.25rem",
                      backgroundColor: variantActiveBgColor,
                      color: variantActiveColor,
                    }}
                    cursor={variantsLength > 0 ? "pointer" : "not-allowed"}
                    color={variantsLength > 0 ? "primary" : "disabled"}
                    onClick={toggleEditorialDescriptionFlag}
                  />
                ) : (
                  <TextFormat
                    sx={{
                      fontSize: "1.25rem",
                      backgroundColor: variantStandardBgColor,
                      color: variantStandardColor,
                    }}
                    cursor={variantsLength > 0 ? "pointer" : "not-allowed"}
                    color={variantsLength > 0 ? "inherit" : "disabled"}
                    onClick={toggleEditorialDescriptionFlag}
                  />
                )}
              </Box>
            </Tooltip>
            <Tooltip
              enterDelay={1500}
              enterNextDelay={1500}
              placement="top"
              title={
                isPartOfTechnicalDescription
                  ? "Remove from Technical"
                  : "Add to Technical"
              }
            >
              <Box component="span" sx={{ display: "inline-block" }}>
                {isPartOfTechnicalDescription ? (
                  <FormatListBulleted
                    sx={{
                      fontSize: "1.25rem",
                      backgroundColor: variantActiveBgColor,
                      color: variantActiveColor,
                      padding: "0.1rem",
                    }}
                    cursor={variantsLength > 0 ? "pointer" : "not-allowed"}
                    color={variantsLength > 0 ? "primary" : "disabled"}
                    onClick={toggleTechnicalDescriptionFlag}
                  />
                ) : (
                  <FormatListBulleted
                    sx={{
                      fontSize: "1.25rem",
                      backgroundColor: variantStandardBgColor,
                      color: variantStandardColor,
                      padding: "0.1rem",
                    }}
                    cursor={variantsLength > 0 ? "pointer" : "not-allowed"}
                    color={variantsLength > 0 ? "inherit" : "disabled"}
                    onClick={toggleTechnicalDescriptionFlag}
                  />
                )}
              </Box>
            </Tooltip>
          </Box>
        )} */}
      </Box>

      <EditorBulletPoints
        key={bulletPoint.id}
        bulletPoint={bulletPoint}
        onRefresh={onRefresh}
        isAddingVariant={isAddingVariant}
        setIsAddingVariant={setIsAddingVariant}
        bulletPointToCopy={bulletPointToCopy}
        setBulletPointToCopy={setBulletPointToCopy}
      />
    </Box>
  );
}
